import * as React from 'react';
import { useEffect, useState } from 'react';
import wrapStore from '@src/utils/wrap-store';
import ProjectStore from './store';
import styles from './index.less';

import aos from '@src/utils/aos';
import cx from 'classnames';
import Link from '@src/components/link';
import BaseSwiper from '@src/components/swiper/base-swiper';
import DateUtil from '@src/utils/date-util';
const ProjectPage = ({ store }) => {
  store.use();
  aos.reInit();

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          if (!isVisible) {
            setIsVisible(true);
            observer.disconnect(); // 一旦显示就停止观察
          }
        }
      },
      {
        threshold: 0.6 // 当10%的元素可见时触发
      }
    );

    const element = document.getElementById('project');
    if (element) {
      observer.observe(element);
    }

    return () => observer.disconnect();
  }, []);

  const LickCom = (item, index) => {
    return (
      <div key={index} className={styles.item} onClick={() => store.onDetailClick(item)}>
        <div className={styles.stateCont} style={{ backgroundImage: `url(${item.item_bg})` }}>
          <div className={`${styles.state} ${item.isRecruit ? styles.stateY : styles.stateN}`}> {item.isRecruit ? '招募中' : '招募结束'}</div>
          <div className={styles.titleCn}>
            {/* <div className={styles.icon} /> */}
            <div className={styles.title}>{item.item_title}</div>
          </div>
        </div>
        <div className={styles.introCont}>
          <div className={styles.introBox}>
            <div className={styles.intro}>{item.info}</div>
            <div className={styles.time}>
              {item.type_text}
              <div className={styles.line} />
              {DateUtil.formatDate(new Date(item.time * 1000), 'yyyy/MM/dd')}截止
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={cx(styles.root, !store.arr.length && styles.rootHide, { [styles.visibleRoot]: isVisible })} id="project">
      <div className={styles.titleCont}>
        <div className={styles.title}>招募项目{store.arrTs}</div>
        <Link
          // target={'_blank'}
          className={styles.detail}
          onClick={() => {
            store.onDetailClick1();
          }}
        >
          查看全部<div className={styles.titleIcn} />
        </Link>
      </div>
      {store.loading ? (
        <div>
          <div className={styles.swiperCont}>
            {store.loading && <BaseSwiper store={store.projectSwiper}>{store.itemList.map((item, index) => LickCom(item, index))}</BaseSwiper>}
          </div>
          <div className={styles.leftBtn} onClick={store.onPrev} />
          <div className={styles.rightBtn} onClick={store.onNext} />
          <div className={styles.indexs}>
            {!!store.indexList.length &&
              store.indexList.map((item, index) => (
                <div
                  key={index}
                  className={cx({
                    [styles.indexDef]: true,
                    [styles.indexActive]: store.indexsActive === index + 1
                  })}
                  onClick={() => store.goSlide(index)}
                />
              ))}
          </div>
        </div>
      ) : (
        <div className={styles.defCont}>{!!store.itemList.length && store.itemList.map((item, index) => LickCom(item, index))}</div>
      )}
      <div className={styles.leftA} />
    </div>
  );
};

export default wrapStore(ProjectPage, ProjectStore);
